import { render, staticRenderFns } from "./CatalogoEstadosActividades.vue?vue&type=template&id=2b5697ac"
import script from "./CatalogoEstadosActividades.vue?vue&type=script&lang=js"
export * from "./CatalogoEstadosActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports